import { HttpParams } from '@angular/common/http';
import { EntityAttributeMetadata } from '@app/core/model/entity-attribute-metadata';
import {IntegrationState} from '@app/views/admin/application-settings/models/integration-state.model';
import {ApplicationProviderListModel} from '@app/views/admin/application-settings/models/application-provider-list.model';

export class Page {
    size = 0;
    totalElements = 0;
    totalPages = 0;
    pageNumber = 1;

    entity: string;
    orgGuid: string;
    applicationId: string;
    showStage = false;
    rosterDataAccessStageTable: string; // granted || revoked
    columns: EntityAttributeMetadata[] = <EntityAttributeMetadata[]>[];
    offset = 0;
    limit: number;
    sort = '';
    orderBy = 'asc';
    idParamName = 'guid';
    sorts = [];
    filter = '';

    constructor() {

    }

    getParams(): HttpParams {
        let params: HttpParams = /* Object.keys(filterParams)
            .map(paramName =>
                typeof filterParams[paramName] === 'object'
                    ? [paramName, filterParams[paramName] ? filterParams[paramName].value : null]
                    : [paramName, filterParams[paramName]]
            )
            .filter(item => item[1] && item[1].trim() !== '')
            .reduce(
                (pageParams: HttpParams, item) => {
                    return pageParams.append(`filter[${item[0]}]`, item[1]);
                },
                new HttpParams()
            )*/
            // .append('attributes',
            //     [this.idParamName, ...this.columns.map(col => col.paramName)]
            //         .join(','))
            new HttpParams()
                .append('filter', this.filter)
                .append('limit', this.limit.toString())
                .append('page', this.pageNumber.toString())
            // .append('offset', this.offset.toString())
            // .append('sort', this.sort)
            // .append('orderBy', this.orderBy)
                .append('org', this.orgGuid);
        if (this.applicationId) {
            params = params.append('applicationId', this.applicationId);
        }
        if (this.showStage) {
            params = params.append('showStage', this.showStage.toString());
        }
        if (this.rosterDataAccessStageTable) {
            params = params.append('rosterDataAccessStageTable', this.rosterDataAccessStageTable);
        }
        if (this.sort) {
            params = params.append('sorting_field', this.sort + '|' + this.orderBy);
        }
        return params;
    }

    setShowStage(application: ApplicationProviderListModel) {
        this.showStage = (application && (application.state === IntegrationState.SIGNIFICANT_CHANGES_DETECTED_IN_CURRENT));
    }
}
